export const TMS_OPTIONS = ['TMW.Suite', 'Truckmate'];

export function requiresTmsSelection(direction) {
    return direction === 'Inbound' || direction === 'Bidirectional';
}

function normalizeEnvironment(environment) {
    return (environment || window.config.ENVIRONMENT || 'dev').toLowerCase();
}

export function buildRoutingKeysPayload(tms, environment) {
    const env = normalizeEnvironment(environment);
    const kafkaTopic =
        tms === 'Truckmate'
            ? `${env}.trimble.transportation.truckmate.syncvisibilitylistener.cmd.0`
            : `${env}.trimble.transportation.enterprise.visibilitysynch.cmd.0`;

    return {
        active: true,
        enableObjectPayload: false,
        kafkaTopic,
        eventTypes: []
    };
}

export function routingKeyExistsForTopic(routingKeys, kafkaTopic) {
    if (!Array.isArray(routingKeys) || !kafkaTopic) {
        return false;
    }

    const normalizedTopic = kafkaTopic.toLowerCase();
    return routingKeys.some(
        (routingKey) =>
            routingKey?.kafkaTopic != null &&
            String(routingKey.kafkaTopic).toLowerCase() === normalizedTopic
    );
}

export function shouldPostRoutingKeys(routingKeys, tms, environment) {
    const { kafkaTopic } = buildRoutingKeysPayload(tms, environment);
    return !routingKeyExistsForTopic(routingKeys, kafkaTopic);
}
